import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './kpi.types';

export const kpiSelectors = {
  ...generateResourceSelectors<types.IKpi>((state) => state.resource.kpi),
};
